"use strict";

exports.__esModule = true;

var ramda_1 = require("ramda");

var utils_1 = require("../utils");

var generateRBACAppConfig = function generateRBACAppConfig(user) {
  var config = {};
  var features = user.features,
      gates = user.gates;
  var isPaidPlan = !!gates.premium_drift || !!gates.premium_team || !!gates.premium_enterprise;
  var isBotsV2User = utils_1.getIsBotsV2User(gates);
  var isRbacAdmin = utils_1.getIsRbacAdmin(user);

  if (isBotsV2User) {
    /*** My settings, Drift Email user ***/
    config = ramda_1.set(ramda_1.lensProp('hasProfile'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmail'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetings'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInSubnav'), false, config);
    /*** Organization settings, Drift Email user ***/

    config = ramda_1.set(ramda_1.lensProp('hasBilling'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasManageTeammates'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasTeams'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasOrgMeetings'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasDataPrivacy'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasSecurity'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasCompany'), false, config);
    /*** App settings, Drift Email user ***/

    config = ramda_1.set(ramda_1.lensProp('hasWidget'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoRouting'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversations'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasBot'), false, config);
    /*** Conversation settings, Drift Email user ***/

    config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasRerouteConversations'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasLimitChatsForReps'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasSessionIntegrationSync'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailPreferencesLink'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasTags'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasInboxes'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasAdvanced'), false, config);
  } else {
    /*** My settings, RBAC user ***/
    config = ramda_1.set(ramda_1.lensProp('hasAccount'), utils_1.hasFeature(features, {
      featureName: "account",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasProfile'), utils_1.hasFeature(features, {
      featureName: "profile",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), utils_1.hasFeature(features, {
      featureName: "drift_assistant_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasEmail'), utils_1.hasFeature(features, {
      featureName: "email_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), utils_1.hasFeature(features, {
      featureName: "notification_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetings'), utils_1.hasFeature(features, {
      featureName: "calendar",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInSubnav'), false, config);
    /*** Organization settings, RBAC user ***/

    config = ramda_1.set(ramda_1.lensProp('hasBilling'), utils_1.hasFeature(features, {
      featureName: "plan_and_billing",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasManageTeammates'), utils_1.hasFeature(features, {
      featureName: "manage_teammates",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasTeams'), utils_1.hasFeature(features, {
      featureName: "teams",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasOrgMeetings'), utils_1.hasFeature(features, {
      featureName: "org_meetings",
      accessLevel: "WRITE"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasDataPrivacy'), utils_1.hasFeature(features, {
      featureName: "data_privacy",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasSecurity'), utils_1.hasFeature(features, {
      featureName: "security",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasCompany'), utils_1.hasFeature(features, {
      featureName: "company_details",
      accessLevel: "READ"
    }), config);
    /*** App settings, RBAC user ***/

    config = ramda_1.set(ramda_1.lensProp('hasWidget'), utils_1.hasFeature(features, {
      featureName: "widget_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoRouting'), utils_1.hasFeature(features, {
      featureName: "routing_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasConversations'), utils_1.hasFeature(features, {
      featureName: "conversation_settings",
      accessLevel: "READ"
    }), config);
    config = ramda_1.set(ramda_1.lensProp('hasBot'), utils_1.hasFeature(features, {
      featureName: "bot_settings",
      accessLevel: "READ"
    }), config);
    /*** Conversation settings, RBAC user ***/

    config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), !!gates.saved_replies, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), isPaidPlan, config);
    config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), isRbacAdmin || !!gates.beta_bulk_close, config);
    config = ramda_1.set(ramda_1.lensProp('hasRerouteConversations'), isRbacAdmin && !!gates.premium_enterprise, config);
    config = ramda_1.set(ramda_1.lensProp('hasLimitChatsForReps'), isRbacAdmin && !!gates.premium_enterprise, config);
    config = ramda_1.set(ramda_1.lensProp('hasSessionIntegrationSync'), isRbacAdmin && utils_1.isProOrAboveOrg(gates), config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailPreferencesLink'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasTags'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasInboxes'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasAdvanced'), isRbacAdmin, config);
  }
  /*** Other settings ***/


  config = ramda_1.set(ramda_1.lensProp('hasAdminSettings'), false, config); // unused in the RBAC world

  config = ramda_1.set(ramda_1.lensProp('hasEditUserChatAccess'), utils_1.hasFeature(features, {
    featureName: "manage_teammates",
    accessLevel: "WRITE"
  }), config);
  config = ramda_1.set(ramda_1.lensProp('hasTeammateAvailabilityToggle'), utils_1.hasFeature(features, {
    featureName: "manage_teammates",
    accessLevel: "WRITE"
  }), config);
  config = ramda_1.set(ramda_1.lensProp('hasHelpDocs'), utils_1.hasFeature(features, {
    featureName: "help_docs",
    accessLevel: "READ"
  }), config);
  /*** Integration settings ***/

  config = ramda_1.set(ramda_1.lensProp('hasIntegrations'), utils_1.hasFeature(features, {
    featureName: "integrations",
    accessLevel: "READ"
  }), config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforce'), isRbacAdmin && (!!gates.premium_team || !!gates.premium_enterprise), config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceRouting'), isRbacAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceRevenueDashboard'), isRbacAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceContactSync'), isRbacAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceUserMapping'), isRbacAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceAttributesMapping'), isRbacAdmin, config);
  return config;
};

exports["default"] = generateRBACAppConfig;